var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf-paginator"},[(_vm.pageCount)?[_vm._v("\n    Página\n    "),_c('span',[_vm._v(_vm._s(_vm.value))]),_vm._v(" / "),_c('span',[_vm._v(_vm._s(_vm.pageCount))])]:_c('input',{attrs:{"type":"number"}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d215ecee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","v-img":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pdf/PDFPaginator.vue
// module id = null
// module chunks = 